import { useDeleteDocumentsFromPropertyMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useDeleteDocumentsFromProperty = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useDeleteDocumentsFromPropertyMutation(headerWithAuth, options);

  return mutate;
};

export {
  useDeleteDocumentsFromProperty,
};
